'use strict';

{
    angular.module('tf.options.service', [])
        .factory('optionPriceService', ['$http', '$q', function($http, $q) {
            return function(underlying, series) {
                return $http.get('/tradefloor/api/options/' + underlying.toUpperCase() + '/' + series.toISOString().substr(0, 10)).then(function(pricesResponse) {
                    return pricesResponse.data;
                });
            }
        }])
    .factory('openInterestService', ['$http', '$q', function($http, $q) {
        return function(underlying) {
            return $http.get('/tradefloor/api/open_interest/security/' + underlying.toUpperCase()).then(function(interestResponse) {
                return interestResponse.data;
            });
        }
    }])
    .factory('spreadService', ['$http', '$q', 'userConfig', function($http, $q, userConfig) {
        return function(underlying, series) {
            if (userConfig.livePrices) {
                return $http.get('/tradefloor/api/spread/' + underlying.toUpperCase() + '/' + series.toISOString().substr(0, 7)).then(function(spreadResponse) {
                    return spreadResponse.data;
                });
            } else {
                return $q.when({
                    asAt : new Date(),
                    spread : {}
                });
            }
        }
    }])
    .factory('chainService', ['$http', '$q', function ($http, $q) {
        return function (underlying) {
            return $http.get('/tradefloor/api/options/' + underlying.toUpperCase()).then(function (chainResponse){
                return processChain(chainResponse.data);
            });

            function processChain(chainData) {
                var sortedSeries = chainData.series.sort(function(a, b) {
                    if (a.expiry > b.expiry) {
                        return 1;
                    }

                    if (a.expiry < b.expiry) {
                        return -1;
                    }

                    return 0;
                });

                var previousSeries = null;

                var chain = {
                    code : underlying,
                    asAt : new Date(chainData.asAt),
                    cvf: chainData.cvf,
                    series : [],
                    codes : {}
                };

                for (var i = 0; i <  sortedSeries.length; i++) {
                    var series = sortedSeries[i];
                    var expiry = new Date(series.expiry);
                    // TODO mutating own fields, not awesome
                    series.expiry = expiry;
                    series.previousSeries = previousSeries;
                    series.nextSeries = null;

                    if (previousSeries != null) {
                        previousSeries.nextSeries = series;
                    }
                    previousSeries = series;


                    var ladder = [];

                    series.ladder = [];

                    series.rungAtOrAfter = function rungAtOrAfter(price) {
                        for (var i = 0; i < this.ladder.length; i++) {
                            var rung = this.ladder[i];
                            if (rung.level >= price) {
                                return rung;
                            }
                        }

                        return this.ladder[this.ladder.length - 1];
                    };

                    for (var j = 0; j < series.data.length; j += 4) {
                        var code = series.data[j];
                        var type = series.data[j + 1];
                        var style = series.data[j + 2];
                        var strike = series.data[j + 3];
                        const isXjo = underlying === "XJO";
                        const isLepo = (isXjo && (strike === 1)) || (!isXjo && (strike === 0.01));

                        var option = {
                            code: code,
                            security: chain,
                            expiry: expiry,
                            strike: strike,
                            style: style == 'A' ? 'AMERICAN' : 'EUROPEAN',
                            type: type == 'P' ? 'PUT' : 'CALL',
                            series: series,
                            cvf: series.cvf
                        };

                        // Record lepos, but do not add them to the chain
                        if (isLepo) {
                            series.lepo = option;
                            continue;
                        }

                        chain.codes[code] = option;

                        var rung = ladder[option.strike];
                        if (rung == null) {
                            rung = {
                                level: option.strike,
                                put: null,
                                call: null
                            };
                            ladder[option.strike] = rung;
                        }
                        option.rung = rung;


                        if (option.type == 'PUT') {
                            rung.put = option;
                        } else if (option.type == 'CALL') {
                            rung.call = option;
                        }
                    }

                    var sortedRungs = Object.keys(ladder).sort(function (a, b) {
                        var aNum = +a;
                        var bNum = +b;

                        if (aNum < bNum)
                            return -1;
                        if (aNum > bNum)
                            return 1;

                        return 0;
                    });

                    var previousRung = null;
                    for (var j = 0; j < sortedRungs.length; j++) {
                        var rung = ladder[sortedRungs[j]];
                        rung.previousRung = previousRung;

                        if (previousRung != null) {
                            previousRung.nextRung = rung;
                        }
                        previousRung = rung;
                        series.ladder.push(rung);
                    }
                    chain.series.push(series);

                }

                return chain;
            }
        };
    }]);


}
